window.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'IFRAME_READY') {
        
        const pathSegments = window.location.pathname.split('/');
        const possibleLang = pathSegments[1]?.toLowerCase();
        
        const supportedLangs = ['es', 'en', 'fr', 'it', 'de'];
        const targetLang = supportedLangs.includes(possibleLang) ? possibleLang : 'en';

        event.source.postMessage({ type: 'SET_LANGUAGE', lang: targetLang }, '*');
    }
});